import type { VizTone } from '@/versions/v1/modules/_viz/viz-tone';
import { controlLoops } from '@/versions/v1/modules/process/Scene.transform';
import { RISK_ENTRIES } from './seed';
import { manualLoopBreaches, riskScore } from './Scene.transform';

export type RiskKpi = {
  id: string;
  label: string;
  value: string;
  tone: VizTone;
};

export function riskKpis(): readonly RiskKpi[] {
  let critical = 0;
  let high = 0;
  for (const risk of RISK_ENTRIES) {
    const { band } = riskScore(risk);
    if (band === 'critical') critical += 1;
    if (band === 'high') high += 1;
  }
  const registered = RISK_ENTRIES.length;
  const manualOver4h = manualLoopBreaches(controlLoops()).length;
  return [
    { id: 'registered', label: 'Registered risks', value: String(registered), tone: 'info' },
    {
      id: 'critical',
      label: 'Critical',
      value: String(critical),
      tone: critical > 0 ? 'bad' : 'neutral',
    },
    {
      id: 'high',
      label: 'High',
      value: String(high),
      tone: high > 0 ? 'warn' : 'neutral',
    },
    {
      id: 'manual',
      label: 'Loops in manual > 4 h',
      value: String(manualOver4h),
      tone: manualOver4h > 0 ? 'warn' : 'neutral',
    },
  ];
}
